import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { PrestadorDiretoriaCargoResponse, PrestadorDiretoriaHistoricoRemocaoRequest, PrestadorDiretoriaRequest, PrestadorDiretoriaResponse, PrestadorDiretoriaVigenteRemocaoRequest } from '@/core/api/sicom-api/registro/prestador/prestador-diretoria.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class PrestadorDiretoriaService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.prestador.diretoria;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    buscar(params: Pessoa, context?: HttpContext): Observable<PrestadorDiretoriaResponse> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf));
        return this.http.get<PrestadorDiretoriaResponse>(this.PATH, { params: httpParams, context });
    }

    atualizar(body: PrestadorDiretoriaRequest, context?: HttpContext): Observable<PrestadorDiretoriaResponse> {
        return this.http.put<PrestadorDiretoriaResponse>(this.PATH, body, { context });
    }

    removerHistorico(body: PrestadorDiretoriaHistoricoRemocaoRequest, context?: HttpContext): Observable<void> {
        return this.http.delete<void>(`${this.PATH}/historico`, { body, context });
    }

    /** Mandatos ainda não encerrados, de qualquer cargo — alimenta a seleção de qual excluir. */
    listarMandatosVigentes(params: Pessoa, context?: HttpContext): Observable<PrestadorDiretoriaCargoResponse[]> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf));
        return this.http.get<PrestadorDiretoriaCargoResponse[]>(`${this.PATH}/mandatos-vigentes`, { params: httpParams, context });
    }

    removerVigente(body: PrestadorDiretoriaVigenteRemocaoRequest, context?: HttpContext): Observable<void> {
        return this.http.delete<void>(`${this.PATH}/vigente`, { body, context });
    }
}
